'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupBox = function (_React$Component) {
  (0, _inherits3.default)(PopupBox, _React$Component);

  function PopupBox() {
    (0, _classCallCheck3.default)(this, PopupBox);
    return (0, _possibleConstructorReturn3.default)(this, (PopupBox.__proto__ || (0, _getPrototypeOf2.default)(PopupBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(PopupBox, [{
    key: 'render',
    value: function render() {
      var styles = require('./PopupBox.scss');

      var classes = styles['PopupBox'];
      classes = classes.concat(" " + (this.props.className || ""));

      return _react2.default.createElement(
        _components.AppSideEffects,
        { scrollTop: 0 },
        _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement(
            'div',
            { className: styles['PopupBox__inner'] },
            this.props.children
          )
        )
      );
    }
  }]);
  return PopupBox;
}(_react2.default.Component);

exports.default = PopupBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupBox/PopupBox.jsx
// module id = 2709
// module chunks = 0